export const FULL_SCREEN_PLAYER = 'FULL_SCREEN_PLAYER' as const;
export const EXIT_FULL_SCREEN_PLAYER = 'EXIT_FULL_SCREEN_PLAYER' as const;
export const SET_HERO_INDEX = 'RESET_INDEX' as const;

export const showFullScreenPlayer = (videoId: string | null) => {
  return {
    type: FULL_SCREEN_PLAYER,
    payload: videoId,
  };
};

export const exitFullScreenPlayer = () => {
  return {
    type: EXIT_FULL_SCREEN_PLAYER,
  };
};

export const setHeroIndex = (index: number | null) => {
  return {
    type: SET_HERO_INDEX,
    payload: index,
  };
};
